import { Injectable } from '@angular/core';
import { Language } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    language: Language[] = [
        {
            name: 'English',
            tag: 'en_US',
            id: 1
        },
        {
            name: 'French',
            tag: 'fr_FR',
            id: 3
        },
        {
            name: 'Japanese',
            tag: 'ja_JA',
            id: 2
        },
        {
            name: 'German',
            tag: 'de_DE',
            id: 5
        },
        {
            name: 'Spanish',
            tag: 'es_ES',
            id: 6
        }
    ];

    constructor() {}

    getName(tag: string | undefined) {
        return this.language.find((t) => t.tag === tag)?.name;
    }

    getId(tag: string) {
        return this.language.find((t) => t.tag === tag)?.id;
    }

    getLanguageCode(languageId: number | undefined): string {
        return (
            this.language
                .find((t) => t.id === languageId)
                ?.tag.split('_')
                .shift()
                ?.toUpperCase() || ''
        );
    }

    getDefaultLanguage(): Language {
        return this.language.find((lang: Language) => lang.name === 'English')!;
    }
}
